import {IconProp} from '@fortawesome/fontawesome-svg-core'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import React, {useMemo} from 'react'
import {createUseStyles} from 'react-jss'

interface BaseIconButtonProps extends React.HTMLAttributes<HTMLDivElement> {
  text?: string
  color: 'primary' | 'secondary'
  disabled?: boolean
}

interface IconButtonFAProps extends BaseIconButtonProps {
  icon: IconProp
}

interface IconButtonUrlProps extends BaseIconButtonProps {
  iconUrl: string
}

interface IconButtonComponentProps extends BaseIconButtonProps {
  iconcomponent: JSX.Element
}

type IconButtonProps =
  | IconButtonFAProps
  | IconButtonUrlProps
  | IconButtonComponentProps

const useStyles = createUseStyles({
  button: ({
    color,
    disabled,
  }: {
    color: 'primary' | 'secondary'
    disabled?: boolean
  }) => ({
    width: 50,
    height: 50,
    borderRadius: '50%',
    backgroundColor: disabled
      ? '#ccc'
      : color === 'primary'
      ? 'var(--e-global-color-ec5822d)'
      : 'red',
    display: 'flex',
    flexDirection: 'column',
    color: disabled ? 'white' : '#eee',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 0 8px -2px black',
    overflow: 'hidden',
  }),
  icon: ({
    color,
    disabled,
  }: {
    color: 'primary' | 'secondary'
    disabled?: boolean
  }) => ({}),
  text: ({
    color,
    disabled,
  }: {
    color: 'primary' | 'secondary'
    disabled?: boolean
  }) => ({
    textOverflow: 'ellipsis',
  }),
})

export default function IconButton(props: IconButtonProps) {
  const divProps = useMemo(() => {
    const dP: any = {...props}
    delete dP.icon
    delete dP.color
    delete dP.text
    if (dP.disabled) {
      dP.onClick = undefined
    }
    return dP
  }, [props])

  const classes = useStyles({color: props.color, disabled: props.disabled})

  return (
    <div {...divProps} className={`${classes.button} ${props.className}`}>
      {'iconUrl' in props ? (
        <img
          alt=""
          src={props.iconUrl}
          style={{
            width: '100%',
            height: '100%',
          }}
        />
      ) : 'iconcomponent' in props ? (
        props.iconcomponent
      ) : (
        <FontAwesomeIcon icon={props.icon} size="lg" />
      )}

      {props.text && <span className={classes.text}>{props.text}</span>}
    </div>
  )
}
